module.exports = __webpack_public_path__ + "img/qq4.492d7541.jpg";